export enum MediaType {
  video,
  image
}
